import { useEffect, useState } from "react";

/** Matches project mobile breakpoint: desktop from `$breakpoint-mobile` (480px). */
export const MOBILE_MEDIA_QUERY = "(max-width: 479px)";

const getInitialMatch = (query: string): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.matchMedia(query).matches;
};

/**
 * Subscribes to a CSS media query and returns whether it currently matches.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => getInitialMatch(query));

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [query]);

  return matches;
};

/** True when viewport width is below the project mobile breakpoint. */
export const useIsMobileViewport = (): boolean =>
  useMediaQuery(MOBILE_MEDIA_QUERY);
